// extracted by mini-css-extract-plugin
export default {"videoSubNav":"VideoSubNav-module_videoSubNav__e1KbP","navItem":"VideoSubNav-module_navItem__huc8r","active":"VideoSubNav-module_active__bqNgR"};